import React from 'react';
import { useTranslation } from 'react-i18next';

// Segmented control for choosing the unit system.
export const UnitToggle = ({ value, onChange, testid = 'unit-toggle', compact = false }) => {
  const { t } = useTranslation();
  const options = [
    { key: 'metric', label: compact ? t('unitToggle.metricCompact') : t('unitToggle.metricFull') },
    { key: 'imperial', label: compact ? t('unitToggle.imperialCompact') : t('unitToggle.imperialFull') },
  ];
  return (
    <div className="inline-flex rounded-xl border border-white/15 bg-[#0A0A0A] p-1" data-testid={testid} role="group" aria-label="Unit system">
      {options.map((o) => (
        <button
          key={o.key}
          type="button"
          onClick={() => onChange(o.key)}
          data-testid={`${testid}-${o.key}`}
          aria-pressed={value === o.key}
          className={`px-3 py-1.5 rounded-lg text-xs sm:text-sm font-medium transition-colors ${
            value === o.key ? 'bg-[#00B4D8] text-black' : 'text-muted-foreground hover:text-white'
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
};
